var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_1468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.85247 9.25689C6.91317 9.1964 6.96396 9.1299 7.00852 9.06059L11.6597 4.40941C12.1132 3.95546 12.1136 3.21954 11.6597 2.76538C11.2058 2.31187 10.4701 2.31144 10.0157 2.76538L6.01044 6.77105L1.98389 2.74515C1.52995 2.29142 0.794247 2.2912 0.340085 2.74515C0.113434 2.97245 -0.000429269 3.2697 1.21607e-06 3.56695C-0.000429269 3.86441 0.113434 4.16188 0.340515 4.38831L5.01193 9.06037C5.05648 9.12989 5.10771 9.19619 5.16884 9.25689C5.40087 9.48892 5.70609 9.60063 6.01044 9.59525C6.31436 9.60085 6.62044 9.48892 6.85247 9.25689Z",
    fill: "#B1BAD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_1468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.690c21f736f1f88f097ba8a29d151359.svg";
export { ForwardRef as ReactComponent };